<template>
  <div>
    <v-row>
      <v-col style="max-width: 290px">
        <!-- Illustration data -->
        <strong class="mb-4">挿絵データ</strong>
        <v-img
          max-height="280"
          height="200"
          max-width="270"
          class="my-2"
          v-if="image"
          :lazy-src="image.fileUrl"
          :src="image.fileUrl"
          aspect-ratio="1.7"
          contain
        />
        <v-img
          max-height="280"
          height="200"
          max-width="270"
          class="my-2"
          v-else
          lazy-src="@/assets/defaultImage.jpg"
          src="@/assets/defaultImage.jpg"
          aspect-ratio="1.7"
          contain
        />
        <div class="d-flex mb-10">
          <v-spacer></v-spacer>
          <base-upload type="image" v-model="image">
            <div slot="activator">
              <v-btn color="primary" small>ファイル選択</v-btn>
            </div>
          </base-upload>
        </div>

        <!-- Audio -->
        <strong>音声データ</strong>
        <audio :key="keyAudio" controls style="max-width: 270px" class="mb-2">
          <source
            :src="audio && audio.fileUrl ? audio.fileUrl : null"
            type="audio/mp3"
          />
          Your browser does not support the audio element.
        </audio>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <base-upload type="audio" v-model="audio">
            <div slot="activator">
              <v-btn color="primary" small>ファイル選択</v-btn>
            </div>
          </base-upload>
        </div>

        <!-- Wordbook Badge -->
        <div class="d-flex">
          <strong class="mt-5">バッヂ表示</strong>
          <v-spacer />
          <v-switch hide-details class="mb-2" v-model="showWordbookBadge" />
        </div>
        <v-select
          :items="listWordbookBadge"
          item-text="name"
          v-if="showWordbookBadge"
          item-value="Id"
          dense
          v-model="wordbookBadge"
          outlined
          class="mt-2"
        />
      </v-col>
      <v-col offset-md="2" offset-lg="2" class="min-width-4">
        <strong>単語名</strong>
        <v-row class="ma-0 mt-2" v-for="(item, index) in lang" :key="index">
          <v-textarea
            :spellcheck="false"
            dense
            :auto-grow="true"
            outlined
            class="max-width-6"
            :rows="2"
            v-model="name[item.key]"
            v-if="item.key == 'ja'"
            :error-messages="nameErrors"
            @input="$v.name.ja.$touch()"
            @blur="$v.name.ja.$touch()"
          >
            <template v-slot:label>
              <span class="font-weight-bold mr-1">{{ item.text }}</span>
              <span class="red--text" v-if="item.key == 'ja'">*</span>
            </template>
          </v-textarea>
          <v-textarea
            :spellcheck="false"
            dense
            :auto-grow="true"
            outlined
            :rows="2"
            class="max-width-6"
            :label="item.text"
            v-model="name[item.key]"
            v-else
          >
            <template v-slot:label>
              <span class="font-weight-bold mr-1">{{ item.text }}</span>
            </template>
          </v-textarea>
        </v-row>
        <strong>ふりがな</strong>
        <v-textarea
          :spellcheck="false"
          dense
          :auto-grow="true"
          outlined
          :rows="2"
          class="max-width-6"
          v-model="furigana"
        />
      </v-col>
    </v-row>
    <v-row class="mt-10" justify="center">
      <v-btn
        color="primary"
        class="mr-10"
        @click="handleUpdateVocabulary"
        :loading="loading"
        :disabled="loading"
        >更新</v-btn
      >
      <v-btn
        color
        @click="
          $router.push({ name: 'Detail Category', params: $route.params })
        "
        >{{ $t("BACK") }}</v-btn
      >
    </v-row>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { updateVocabulary, getDetailVocabulary } from "@/api/Vocabulary.api";
import uploadFile from "@/utils/uploadFile";
import { getListBadge } from "@/api/Badge.api";
export default {
  mixins: [validationMixin],
  data() {
    return {
      lang: [
        { text: "日本語", key: "ja" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
      name: {
        ja: "",
        en: "",
        cn: "",
        vn: "",
        bn: "",
        pt: "",
      },
      furigana: "",
      image: null,
      loading: false,
      showWordbookBadge: false,
      wordbookBadge: "",
      keyAudio: 0,
      audio: null,
      listWordbookBadge: [],
    };
  },
  validations() {
    return {
      name: {
        ja: {
          required,
        },
      },
      // furigana: { required },
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.ja.$dirty) return errors;
      !this.$v.name.ja.required && errors.push("日本語を入力してください。");
      return errors;
    },
    // furiganaErrors() {
    //   const errors = [];
    //   if (!this.$v.furigana.$dirty) return errors;
    //   !this.$v.furigana.required && errors.push("ふりがなを入力してください。");
    //   return errors;
    // },
  },
  watch: {
    audio: function () {
      this.keyAudio++;
    },
    showWordbookBadge: function (val) {
      if (!val) {
        this.wordbookBadge = "";
      }
    },
  },
  async created() {
    await this.handleGetDetailVocabulary();
    await this.getBagdeList();
  },
  methods: {
    async getBagdeList() {
      await getListBadge()
        .then(({ result }) => {
          this.listWordbookBadge = result;
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    async handleGetDetailVocabulary() {
      const { vocabularyId, categoryId } = this.$route.params;
      let params = {
        id: vocabularyId,
        category: categoryId,
      };
      await getDetailVocabulary(params)
        .then(({ result }) => {
          const {
            name,
            image_url,
            audio_url,
            badge,
            furigana,
            badgeChecked,
          } = result;
          this.name = name;
          this.wordbookBadge = badge;
          this.furigana = furigana;
          this.showWordbookBadge = badgeChecked;
          if (image_url) {
            this.image = {
              fileUrl: image_url,
            };
          }
          if (audio_url) {
            this.audio = {
              fileUrl: audio_url,
            };
          }
        })
        .catch((error) => {
          this.$toast.errors(error);
        });
    },
    async handleUpdateVocabulary() {
      this.$v.$touch();
      if (!this.$v.$anyError) {
        this.loading = true;
        const { name, furigana, wordbookBadge, showWordbookBadge } = this;
        const { vocabularyId, categoryId } = this.$route.params;
        let params = {
          id: vocabularyId,
          name,
          category: categoryId,
          badge: wordbookBadge,
          furigana,
          badgeChecked: showWordbookBadge,
        };
        await this.checkFile(params);
        await updateVocabulary(params)
          .then(() => {
            this.loading = false;
            this.$router.go(-1);
          })
          .catch((error) => {
            this.$toast.error(error);
            this.loading = false;
          });
      }
    },
    async checkFile(params) {
      if (this.image && this.image.file) {
        await uploadFile(this.image.file, "image").then((e) => {
          params.dataImage = e;
        });
      }
      if (this.audio && this.audio.file) {
        await uploadFile(this.audio.file, "audio").then((e) => {
          params.dataSound = e;
        });
      }
      return params;
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
      this.dialogUpdateVocabulary = false;
    },
  },
};
</script>
<style scoped>
.pad-top-bottom {
  padding-top: 0;
  padding-bottom: 0;
}
.upload-file {
  text-align: center;
  height: 300px;
  border: 2px dashed #20a8d8;
  display: flex;
  justify-content: center;
}
</style>